'use client';

import { useTranslations } from 'next-intl';
import { IconButton, Tooltip } from '@terra/ui-design-system';
import { UserAdd01Icon } from '@terra/ui-icons';
import { useTargetId } from '../../store/projectStore';
import { useBoothHandoff } from '../../hooks/useBoothHandoff';
import { useFeatureFlags } from '../../hooks/useFeatureFlags';
import { requestBoothTourRestart } from './booth-tour-restart';

export function BoothStationResetButton() {
  const { isFeatureFlagEnabled: tourEnabled } =
    useFeatureFlags('BOOTH_TOUR_ENABLED');
  const targetId = useTargetId();
  const t = useTranslations('boothTour');
  const handoffNextPlayer = useBoothHandoff({
    onRestartTour: requestBoothTourRestart,
  });

  if (!tourEnabled || !targetId) {
    return null;
  }

  return (
    <Tooltip title={t('nextPlayer')}>
      <IconButton
        variant="ghost"
        size="xs"
        onClick={() => {
          void handoffNextPlayer();
        }}
        aria-label={t('nextPlayerAriaLabel')}
      >
        <UserAdd01Icon size={16} strokeWidth={1.75} />
      </IconButton>
    </Tooltip>
  );
}
